const getAssetURL = (assetUrl?: string, key?: string, _presignedUrl?: string) => {
  if (!key || !assetUrl) {
    return _presignedUrl;
  }

  const url = new URL(`/${key}`, `${assetUrl}`).href;
  return url;
}

const buildQueryString = (params: any) => {
  return Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&');
};

const getUuidFromUrl = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    
    const segments = parsedUrl.pathname
      .split('/')
      .filter(Boolean); // removes empty strings

    return segments[segments.length - 1] ?? null;
  } catch {
    return null;
  }
};




export { getAssetURL, buildQueryString, getUuidFromUrl };
